import React from "react";
import KucukcekmeceSidebar from "../Sidebar/KucukcekmeceSidebar";
// import KüçükçekmeceOtherServices from "../ServiceAreas/KucukcekmeceServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const KüçükçekmeceIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        KÜÇÜKÇEKMECE HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        

        {/* İçerik */}
          <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Kaliteli temizlik gerektikçe İstanbul’daki birçok muayel yıkama çözümü
            cazip tarifik kampanya afişleriyle dolu olur. İstanbul Temizlik Servisi tam
            anlamıyla hijyenik ve detaylı hizmet sunar. Halılarınız,
            koltuklarınız ve ev tekstil ürünleriniz, %100 müşteri memnuniyeti
            odaklı bir hizmet anlayışıyla teslim alınır, özel sistemlerle
            detaylı şekilde yıkanır ve zamanında geri teslim edilir.
          </p>

          <p>
            Evde çocuk, yaşlı, alerjik birey varsa, temizliğinizin kalitesine
            güvenmek sizin de en doğal hakkınız. Bu yüzden biz sadece temizlik
            değil; hijyen, güvenlik ve zamanında teslim sözünü de veriyoruz.
            Ayrıca her halı için uygun yıkama yöntemi kullanılır.
          </p>

          <p>
            <strong>
              İstanbul Temizlik Servisi olarak sağladığımız avantajlar şunlardır:
            </strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Daha Sağlıklı Bir Çevre</li>
            <li>
              Derinlemesine temizlik: Halı, koltuk, perde, yorgan, battaniye
              gibi tüm ev tekstili ürünlerinde tam çözüm
            </li>
            <li>Antibakteriyel ve Alerjenlerden Arınmış Hijyen</li>
            <li>Yerinde Yıkama & Fabrikada Yıkama Seçeneği</li>
            <li>Kısa Sürede Teslim</li>
            <li>Leke Çıkartma Garantisi</li>
          </ul>

          <p>
            Halılarınızda oluşan lekeleri, tozları, kötü kokuları gideriyoruz.
            Koltuk yıkamada ise kumaş yapısına göre uygun kimyasal ve buhar
            sistemi kullanıyoruz.
          </p>

          <p>
            Çakırlar, Demet, İvedik gibi birçok mahallede mobil araçlarımızla
            aynı gün içinde yerinden alım ve teslimat hizmetimiz mevcuttur.
          </p>

          <p>
            Koltuk yıkama, halı şampuanı ve buharlı sistemlerle yapılan detaylı
            bir işlemdir. Kumaşa zarar vermeden, kir tabakasını yok eder,
            alerjenleri yok eder.
          </p>

          <p>
            Bazı durumlarda, halı tamparsuru ve buharlı temizleme makineleri
            gibi halılarınızın kabarma ve konumlarını bozmayacak özel ekipmanlar
            kullanılır. Bu sayede hem görünüm hem de temizlik seviyesi artar.
            Ayrıca halılarınız özel filelerle paketlenerek teslim edilir.
          </p>

          <p>
            Hizmet verdiğimiz tüm mahallelerde, profesyonel ve güler yüzlü
            personelimizle çalışıyoruz. Batıkent, Ergazi, Demetevler, Ata gibi
            tüm lokasyonlara hızlı servis!
          </p>

          <p>
            Bizim için müşteri memnuniyeti her şeydir. Halı ve koltuk yıkama
            gibi hijyenik çözümlerde bizi tercih ettiğiniz için teşekkür ederiz.
            Hemen <strong>iletisim</strong> sayfamızdan bize ulaşarak sipariş
            verebilir veya fiyat bilgisi alabilirsiniz.
          </p>
          {/* Sol sidebarlar */}
      
          <KucukcekmeceSidebar />
          {/* <KüçükçekmeceOtherServices /> */}
       
        </div>
        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

          {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default KüçükçekmeceIntro;
